import { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AccountHolder from "./pages/AccountHolder";
import AddStudent from "./pages/AddStudent";
import Branch from "./pages/Branch";
import Course from "./pages/Course";
import Dashboard from "./pages/Dashboard";
import DayBookReport from "./pages/DayBookReport";
import { DropDownMaster } from "./pages/DropDownMaster";
import EditStudent from "./pages/EditStudent";
import FeesDetailsReport from "./pages/FeesDetailsReport";
import FeesMaster from "./pages/FeesMaster";
import FeesSummaryReport from "./pages/FeesSummaryReport";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import MainStudentView from "./pages/MainStudentView";
import NotFoundPage from "./pages/NotFoundPage";
import QualificationMaster from "./pages/QualificationMaster";
import RoleManagement from "./pages/RoleManagement";
import StudentAttachment from "./pages/StudentAttachment";
import StudentConsessionByRegisterNo from "./pages/studentConsessionByRegNo";
import StudentFees from "./pages/StudentFees";
import StudentFeesByRegisterNo from "./pages/studentFeesByRegNo";
import StudentFeesCancelByRegNo from "./pages/studentFeesCancelByRegNo";
import StudentFeesRefundByAdmNo from "./pages/StudentFeesRefundByAdmNo";
import StudentPdfForm from "./pages/StudentFormPDF";
import StudentMiscFeesByRegisterNo from "./pages/studentMiscFeesByRegNo";
import TotalFeesSummaryReport from "./pages/TotalFeesSummaryReport";
import Transaction from "./pages/Transaction";
import User from "./pages/User";
import { AuthUserType } from "./redux/actions/authUserActions";
import { fetchBranch } from "./redux/actions/branchActions";
import { fetchDropDown } from './redux/actions/dropDownAction';
import { fetchUser } from "./redux/actions/userActions";
import { StoreState } from "./redux/reducers";
import { AppDispatch } from "./redux/store";
import BillingReport from "./pages/BillingReport";
import StudentFeesDetails from "./pages/StudentFeesDetails";
import TotalStudentFeesSummary from "./pages/TotalStudentFeesSummary";
import IncomeExpenseReport from "./pages/IncomeExpenseReport";

function App() {

    const dispatch = useDispatch<AppDispatch>()
    const authUser = useSelector<StoreState, AuthUserType>((state: any) => state.authUser)

    // const authendicated = true
    const authenticated = typeof authUser.token === 'string' && authUser.token !== undefined && authUser.token !== ''

    useEffect(() => {
        if (authenticated) {
            dispatch(fetchUser())
            dispatch(fetchBranch())
            dispatch(fetchDropDown())
        }
    }, [authenticated])

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={authenticated ? <Dashboard /> : <Navigate to='/login' />} />
                <Route path="/branch" element={authenticated ? <Branch /> : <Navigate to='/' />} />
                <Route path="/login" element={!authenticated ? <Login /> : <Navigate to='/' />} />
                <Route path="/logout" element={authenticated ? <Logout /> : <Navigate to='/' />} />
                <Route path="/course" element={authenticated ? <Course /> : <Navigate to='/' />} />
                <Route path="/fees-master" element={authenticated ? <FeesMaster /> : <Navigate to='/' />} />
                <Route path="/qualification-master" element={authenticated ? <QualificationMaster /> : <Navigate to='/' />} />
                <Route path="/student" element={authenticated ? <MainStudentView /> : <Navigate to='/' />} />
                <Route path="/student-info" element={authenticated ? <AddStudent /> : <Navigate to='/' />} />
                <Route path="/student-fees/:id" element={authenticated ? <StudentFees /> : <Navigate to='/' />} />
                <Route path="/student-info/:id" element={authenticated ? <EditStudent /> : <Navigate to='/' />} />
                <Route path="/student-attachment/:id" element={authenticated ? <StudentAttachment /> : <Navigate to='/' />} />
                <Route path="/user" element={authenticated ? <User /> : <Navigate to='/' />} />
                <Route path="/role-permissions" element={authenticated ? <RoleManagement /> : <Navigate to='/' />} />
                <Route path="/dropdown-master" element={authenticated ? <DropDownMaster /> : <Navigate to='/' />} />
                <Route path="/student-billing" element={authenticated ? <StudentFeesByRegisterNo /> : <Navigate to='/' />} />
                <Route path="/student-cancel-billing" element={authenticated ? <StudentFeesCancelByRegNo /> : <Navigate to='/' />} />
                <Route path="/student-refund-billing" element={authenticated ? <StudentFeesRefundByAdmNo /> : <Navigate to='/' />} />
                <Route path="/student-concession" element={authenticated ? <StudentConsessionByRegisterNo /> : <Navigate to='/' />} />
                <Route path="/student-misc-fees" element={authenticated ? <StudentMiscFeesByRegisterNo /> : <Navigate to='/' />} />
                <Route path="/student-fees-report" element={authenticated ? <FeesDetailsReport /> : <Navigate to='/' />} />
                <Route path="/fees-summary-report" element={authenticated ? <FeesSummaryReport /> : <Navigate to='/' />} />
                <Route path="/totalfees-summary-report" element={authenticated ? <TotalFeesSummaryReport /> : <Navigate to='/' />} />
                <Route path="/transaction" element={authenticated ? <Transaction /> : <Navigate to='/' />} />
                <Route path="/account-holder" element={authenticated ? <AccountHolder /> : <Navigate to='/' />} />
                <Route path="/daybook_report" element={authenticated ? <DayBookReport /> : <Navigate to='/' />} />
                <Route path="*" element={authenticated ? <NotFoundPage /> : <Navigate to='/' />} />
                <Route path="/student-form-pdf" element={authenticated ? <StudentPdfForm /> : <Navigate to='/' />} />
                 <Route path="/bill-report" element={authenticated ? <BillingReport /> : <Navigate to='/' />} />
                 <Route path="/student-fees-details" element={authenticated ? <StudentFeesDetails /> : <Navigate to='/' />} />
                 <Route path="/total-student-fees-summary" element={authenticated ? <TotalStudentFeesSummary /> : <Navigate to='/' />} />
                  <Route path="/inome-expenditure" element={authenticated ? <IncomeExpenseReport /> : <Navigate to='/' />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
